// export const server = "http://192.168.88.76:5006/api/v1";
export const server = "https://doitserver.appdeploy.in/api/v1";
